import { Route } from '@angular/router';
import { gamesOnlineLeaveBusterGuard } from 'src/app/modules/games/guards/games-online-leave-buster.guard';

export const cricketTacticsOnlineGameRoutes: Route[] = [
    {
        path: 'online-game/cricket-tactics',
        data: {
            hideTournamentNotification: true,
        },
        canDeactivate: [gamesOnlineLeaveBusterGuard],
        loadComponent: () =>
            import('./pages/cricket-tactics-online-gameplay/cricket-tactics-online-gameplay.component').then(
                (c) => c.CricketTacticsOnlineGameplayComponent
            ),
    },
];

export const cricketTacticsSpectateOnlineGameRoutes: Route[] = [
    {
        path: 'online-game/cricket-tactics/spectate/:id',
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('./pages/cricket-tactics-online-spectator/cricket-tactics-online-spectator.component').then(
                (c) => c.CricketTacticsOnlineSpecatorComponent
            ),
    },
];
